<template>
  <div>
    <div v-if="activities.length === 0">
      Egyelőre nincs rögzített eseményhez ehhez az elemhez.
    </div>
    <el-timeline class="activity-timeline">
      <el-timeline-item
        v-for="activity in activities"
        :key="activity.id"
        :timestamp="$options.filters.dateTime(activity.created_at)"
        placement="top"
        :icon="getInfo(activity.description, activity.causer).icon"
        :color="getInfo(activity.description, activity.causer).color"
      >
        <el-card>
          <div slot="header">
            <el-button v-if="activity.causer" type="text" style="padding: 0;" @click="navigateToUser(activity.causer)">
              {{ getInfo(activity.description, activity.causer).causer }}
            </el-button>
            <span v-if="!activity.causer">Ismeretlen felhasználó </span>
            {{ getInfo(activity.description, activity.causer).action }}
          </div>
          <el-table
            v-if="getDiff(activity.properties.old, activity.properties.attributes).length"
            :data="getDiff(activity.properties.old, activity.properties.attributes)"
          >
            <el-table-column
              label="Mező"
              prop="label"
            />
            <el-table-column
              label="Régi érték"
              prop="old"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div v-if="formatters && formatters[scope.row.key]">
                  <el-tag
                    v-if="formatters[scope.row.key](scope.row.old).tag && formatters[scope.row.key](scope.row.old).value"
                    :type="formatters[scope.row.key](scope.row.old).tag"
                    size="small"
                  >
                    <span>{{ formatters[scope.row.key](scope.row.old).value }}</span>
                  </el-tag>
                  <template v-else>
                    {{ formatters[scope.row.key](scope.row.old).value }}
                  </template>
                </div>
                <template v-else>
                  {{ scope.row.old }}
                </template>
              </template>
            </el-table-column>
            <el-table-column
              label="Új érték"
              prop="attribute"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div v-if="formatters && formatters[scope.row.key]">
                  <el-tag
                    v-if="formatters[scope.row.key](scope.row.attribute).tag"
                    :type="formatters[scope.row.key](scope.row.attribute).tag"
                    size="small"
                  >
                    {{ formatters[scope.row.key](scope.row.attribute).value }}
                  </el-tag>
                  <span v-else>{{ formatters[scope.row.key](scope.row.attribute).value }}</span>
                </div>
                <template v-else>
                  {{ scope.row.attribute }}
                </template>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-if="getDiff(activity.properties.old, activity.properties.attributes).length === 0"
            style="word-break: normal;"
          >
            Ehhez az eseményhez nem mutatható változás. Ez akkor lehetséges, ha rejtett mező módosult (például jelszó).
          </div>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
export default {
  props: ['activities', 'propsMap', 'formatters'],
  methods: {
    navigateToUser(user) {
      this.$router.push('/users/view/' + user.id);
    },
    getInfo(description, causer) {
      switch (description) {
        case 'created':
          return {
            icon: 'el-icon-plus',
            color: '#67C23A',
            causer: `${causer && causer.last_name || ''} ${causer && causer.first_name || ''} (@${causer && causer.username || ''})`,
            action: `létrehozott`,
          };
          break;
        case 'updated':
          return {
            icon: 'el-icon-edit',
            color: '#E6A23C',
            causer: `${causer && causer.last_name || ''} ${causer && causer.first_name || ''} (@${causer && causer.username || ''})`,
            action: `módosított`,
          };
          break;
      }
    },
    getDiff(old, attributes) {
      const diffs = Object.keys(attributes)
        .reduce((diff, key) => {
          if ((attributes[key] || null) === (old && old[key] || null)) return diff;
          return {
            ...diff,
            [key]: {
              key,
              label: this.propsMap[key],
              attribute: attributes[key],
              old: old && old[key] || '',
            }
          };
        }, {});
      const diffArray = [];
      for (let key in diffs) {
        diffArray.push(diffs[key]);
      }
      return diffArray;
    }
  },
};
</script>

<style lang="scss">
  .el-timeline.activity-timeline {
    padding-top: 5px;
    padding-left: 6px;
    .el-timeline-item__node--normal {
      left: -6px;
      top: -3px;
      width: 22px;
      height: 22px;
    }
  }
</style>
